import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../App';
import { useCart } from '../../App';

const Cart = () => {
  const { isNightMode } = useTheme();
  const { cartItems, updateItemQuantity, removeItem, clearCart, cartTotal } = useCart();
  const navigate = useNavigate();

  const handleQuantityChange = (id, quantity) => {
    if (quantity < 1) return;
    updateItemQuantity(id, quantity);
  };

  const handleRemoveItem = (id) => {
    const confirmed = window.confirm('Are you sure you want to remove this item from cart?');
    if (confirmed) {
      removeItem(id);
    }
  };

  const handleClearCart = () => {
    const confirmed = window.confirm('Are you sure you want to clear your entire cart?');
    if (confirmed) {
      clearCart();
    }
  };

  const formatPrice = (price) => {
    return `Rs. ${price.toFixed(2)}`;
  };

  return (
    <main style={{
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      background: isNightMode ? '#020617' : '#ffffff',
      color: isNightMode ? '#ffffff' : '#000000',
      minHeight: '100vh'
    }}>
      <div style={{
        background: isNightMode ? '#1e293b' : '#ffffff',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: isNightMode ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.05)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px'
        }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            margin: '0',
            color: isNightMode ? '#ffffff' : '#000000'
          }}>
            Shopping Cart
          </h1>
          {cartItems.length > 0 && (
            <button
              onClick={handleClearCart}
              style={{
                padding: '8px 16px',
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear Cart
            </button>
          )}
        </div>

        {cartItems.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: isNightMode ? '#cbd5e1' : '#6b7280'
          }}>
            <div style={{
              fontSize: '4rem',
              marginBottom: '20px'
            }}>
              🛒
            </div>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '10px',
              color: isNightMode ? '#ffffff' : '#000000'
            }}>
              Your cart is empty
            </h2>
            <p style={{ marginBottom: '30px' }}>
              Looks like you haven't added any products to your cart yet.
            </p>
            <button
              onClick={() => navigate('/products')}
              style={{
                padding: '12px 24px',
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div>
            <div style={{
              display: 'grid',
              gap: '20px',
              marginBottom: '30px'
            }}>
              {cartItems.map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '80px 1fr auto',
                    gap: '20px',
                    padding: '20px',
                    background: isNightMode ? '#0f172a' : '#f9fafb',
                    borderRadius: '8px',
                    alignItems: 'center'
                  }}
                >
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: '#e5e7eb',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem'
                  }}>
                    📦
                  </div>
                  
                  <div>
                    <h3 style={{
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      marginBottom: '5px',
                      margin: '0',
                      color: isNightMode ? '#ffffff' : '#000000'
                    }}>
                      {item.name}
                    </h3>
                    {item.brand && (
                      <p style={{
                        fontSize: '0.9rem',
                        color: isNightMode ? '#cbd5e1' : '#6b7280',
                        margin: '0 0 10px 0'
                      }}>
                        {item.brand}
                      </p>
                    )}
                    <p style={{
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      color: '#10b981',
                      margin: '0'
                    }}>
                      {formatPrice(item.price)}
                    </p>
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '10px'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}>
                      <button
                        onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                        style={{
                          width: '30px',
                          height: '30px',
                          border: '1px solid #d1d5db',
                          background: isNightMode ? '#1e293b' : '#ffffff',
                          color: isNightMode ? '#ffffff' : '#000000',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        -
                      </button>
                      <span style={{
                        minWidth: '40px',
                        textAlign: 'center',
                        fontWeight: '500'
                      }}>
                        {item.quantity}
                      </span>
                      <button
                        onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                        style={{
                          width: '30px',
                          height: '30px',
                          border: '1px solid #d1d5db',
                          background: isNightMode ? '#1e293b' : '#ffffff',
                          color: isNightMode ? '#ffffff' : '#000000',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        +
                      </button>
                    </div>
                    <button
                      onClick={() => handleRemoveItem(item.id)}
                      style={{
                        padding: '6px 12px',
                        background: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px',
              background: isNightMode ? '#0f172a' : '#f9fafb',
              borderRadius: '8px',
              borderTop: '2px solid #3b82f6'
            }}>
              <div>
                <p style={{
                  fontSize: '1.1rem',
                  color: isNightMode ? '#cbd5e1' : '#6b7280',
                  margin: '0 0 5px 0'
                }}>
                  Total ({cartItems.length} items)
                </p>
                <p style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: isNightMode ? '#ffffff' : '#000000',
                  margin: '0'
                }}>
                  {formatPrice(cartTotal)}
                </p>
              </div>
              <div style={{
                display: 'flex',
                gap: '10px'
              }}>
                <button
                  onClick={() => navigate('/products')}
                  style={{
                    padding: '12px 24px',
                    background: 'transparent',
                    color: isNightMode ? '#ffffff' : '#000000',
                    border: '2px solid #d1d5db',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}
                >
                  Continue Shopping
                </button>
                <button
                  style={{
                    padding: '12px 24px',
                    background: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default Cart;
